import { Translations } from '../types/translation';
import { deTerms } from './de-terms';

export const DeLanguage: Record<Translations, string> = {
    login: 'Einloggen',
    logout: 'Ausfahrt',
    profile: 'Profil',
    makeOrder: 'Paketversand',
    myOrders: 'Meine Bestellungen',
    delete: 'Löschen',
    name: 'Name',
    phone: 'Telefonnummer',
    surname: 'Nachname',
    transactions: 'Transaktionen',
    uploadPhoto: 'Foto hochladen',
    userSettings: 'Benutzereinstellungen',
    email: 'Email',
    save: 'Speichern',
    transactionsEmpty: 'Transaktionenliste ist leer',
    addressSettings: 'Einstellungen der Adresse',
    apartmentNumber: 'Wohnungsnummer',
    city: 'Stadt',
    country: 'Land',
    district: 'Bezirk',
    entrance: 'Eingang',
    houseNumber: 'Haus',
    region: 'Region',
    street: 'Straße',
    cancel: 'Stornierung',
    userDeleteContent: 'Nach dem Löschen, wird das Benutzerkonto unzugänglich',
    userDeleteTitle: 'Möchten Sie Ihr Benutzerkonto wirklich löschen?',
    applicationCompleted: 'Anmeldung abgeschlossen',
    deliveryDate: 'Zeitfenster der voraussichtlichen Lieferung',
    direction: 'Richtung',
    fromWhom: 'Von wem',
    paid: 'Bezahlt',
    sendTime: 'Zeit der Abgabe',
    shippingCompany: 'Beförderndes Unternehmen',
    status: 'Status',
    toWhom: 'An wen',
    trackingNumber: 'Sendungsverfolgungsnummer',
    editOrder: 'Bestellung redaktieren',
    payOrder: 'Bestellung bezahlen',
    payOrderTitle: 'Bezahlung von Bestellungsnummer …',
    currency: 'Währung',
    sum: 'Menge',
    pay: 'Bezahlen',
    orderFrom: 'Woher',
    orderPackageCost: 'Preise',
    orderPackageHeight: 'Höhe',
    orderPackageItemsCount: 'Anzahl der Artikel',
    orderPackageLength: 'Länge',
    orderPackageCode: 'HS-Code',
    orderPackageName: 'Paketinhalt',
    orderPackageRuName: 'Paketinhalt auf Russisch',
    orderPackageWeight: 'Gewicht',
    orderPackageWidth: 'Breite',
    orderPackageInformation: 'Informationen zur Sendung',
    orderTo: 'Wohin',
    back: 'Zurück',
    next: 'Weiter',
    update: 'Aktualisieren',
    checkout: 'Checkout',
    orderConfirmation: 'Bestätigung',
    orderFiller: 'Besteller',
    orderFromTo: 'Woher-Wohin',
    orderRecipient: 'Empfänger',
    orderSender: 'Absender',
    orderTransportation: 'Transport',
    orderDeliveryToCompanyTypeTitle: 'Transfermöglichkeit zu uns',
    orderFillerEmail: 'Email des Bestellers',
    orderPayer: 'Zahler',
    orderMemberRecipientEmail: 'Email',
    orderMemberRecipientFullAddress: 'Volle Adresse',
    orderMemberRecipientName: 'Name',
    orderMemberRecipientPhone: 'Telefon',
    orderMemberRecipientPostalCode: 'Postleitzahl',
    orderMemberRecipientSurname: 'Nachname',
    orderMemberRecipientMiddlename: 'Zweiter Vorname',
    orderMemberSenderEmail: 'Email',
    orderMemberSenderFullAddress: 'Volle Adresse',
    orderMemberRecipientCity: 'Stadt',
    orderMemberRecipientStreet: 'Straße',
    orderMemberRecipientHouse: 'Haus',
    orderMemberRecipientBuilding: 'Gebäudenummer',
    orderMemberRecipientApartment: 'Wohnungsnummer',
    orderMemberRecipientRegion: 'Empfängerregion',
    orderMemberRecipientRepresentative: 'Der Name des Vertreters des Begünstigten',
    orderMemberSenderName: 'Name',
    orderMemberSenderPhone: 'Telefon',
    orderMemberSenderPostalCode: 'Postleitzahl',
    orderMemberSenderSurname: 'Nachname',
    orderMemberSenderMiddlename: 'Zweiter Vorname',
    orderMemberSenderCity: 'Stadt',
    orderMemberSenderStreet: 'Straße',
    orderMemberSenderHouse: 'Haus',
    orderMemberSenderBuilding: 'Gebäudenummer',
    orderMemberSenderApartment: 'Wohnungsnummer',
    orderMemberSenderRegion: 'Region des Absenders',
    orderMemberPassport: 'Passport',
    orderMemberPassportDate: 'Datum der Ausstellung',
    orderMemberPassportDivisionCode: 'Code der zuständigen Behörde',
    orderMemberPassportIssuingAuthority: 'Ausgestellt von',
    orderMemberPassportNumber: 'Passport Nummer',
    orderMemberPassportSerialNumber: 'Passport Seriennummer',
    orderCancel: 'Abbrechen',
    orderConfirm: 'Bestellung bestätigen',
    userInfoUpdatedMessage: 'Benutzerinformationen erfolgreich aktualisiert',
    userPhotoUpdatedMessage: 'Benutzerfoto erfolgreich aktualisiert',
    no: 'Nein',
    yes: 'Ja',
    authorization: 'Anmeldung',
    authorizationByEmail: 'mit Email',
    authorizationByPhone: 'mit Telefon',
    authorizationType: 'Art der Anmeldung',
    passwordForgot: 'Password vergessen',
    registration: 'Registrierung',
    password: 'Passwort',
    field: 'Feld',
    isMandatory: 'ist notwendig',
    enteredIncorrectly: 'falsch eingegeben',
    confirmPassword: 'Passwortbestätigung',
    register: 'Sich registrieren',
    passwordsDoNotMatch: 'Die eingegebenen Passwörter stimmen nicht überein ',
    registrationRejected: 'Anmeldung abgelehnt',
    registrationRejectedMessage: 'Sie haben den Nutzungsbedingungen nicht zugestimmt',
    serviceName: 'Telega',
    termsOfService: 'Nutzungsbedingungen von Dienstleistungen',
    passwordRestore: 'Passwort wiederherstellen',
    passwordRestoreMessage: 'Der Code zum Zurücksetzen des Passworts wird an die Email gesendet',
    passwordRestoredMessage: 'Das Passwort wurde erfolgreich zurückgesetzt',
    restore: 'Wiederherstellen',
    accept: 'Annehmen',
    welcome: 'Herzlich Willkommen',
    goToOrdersList: 'Zu der Bestellungsliste',
    orderPlacedSuccessfully: 'Bestellung erfolgreich gemacht',
    yourOrderNumber: 'Ihre Bestellungsnummer',
    httpRequestUnexpectedError: 'Unvorhersehbarer Fehler',
    httpRequestServeError: 'Fehler beim Laden der Daten',
    httpRequestUserNotAuthorized: 'Benutzer ist nicht angemeldet',
    httpRequestUserNotFound: 'Suchanfrage konnte nicht gefunden werden',
    termsContent: deTerms,
    orderCreatedDate: 'Datum der Bestellung',
    emailNotConfirmed: 'Die Email wurde nicht bestätigt',
    confirm: 'Bestätigen',
    confirmationCode: 'Bestätigungscode',
    getQrCode: 'QR-Code erhalten',
    amountToPay: 'Betrag',
    paySucceed: 'Die Zahlung war erfolgreich',
    deliveryTime: 'Lieferzeit',
    deliveryType: 'Tarif',
    orderQrInfo: 'Bitte scannen Sie diesen Code mit Ihrem Smartphone oder Tablet und das Label wird auf Ihrem Gerät gespeichert. Packen Sie Ihr Paket und bringen Sie es zum nächstgelegenen GLS-PaketShop in Ihrer Stadt. Legen Sie diesen Aufkleber vor Ort vor, der Abteilungsmitarbeiter druckt ihn aus und klebt ihn auf Ihr Paket.',
    inputOfLatinLetters: 'Es sind nur englischen Zeichen erlaubt',
    amountToPayChanged: 'Der Bestellpreis hat sich geändert',
    incorrectPhoneNumber: 'Telefonnummer falsch eingegeben',
    paymentTypeSelection: 'Wählen Sie die Art des Zahlungssystems',
    maxLength: 'Maximale Länge',
    maxGirth: 'Maximaler Umfang',
    maxWeight: 'Maximales Gewicht',
    sanctionedGoodsInfo: 'Wir bitten Sie, sich mit der Liste der sanktionierten Waren vertraut zu machen, deren Einfuhr in die Russische Föderation verboten ist',
    deleteConfirmation: 'Möchten Sie den ausgewählten Datensatz wirklich löschen?',
    confirmAction: 'Aktion bestätigen',
    orderPackageItemDuty: 'Sendungen im Wert von über {amount} Euro unterliegen einer Zollgebühr von {percent}%, wenn der angegebene Wert der Schwelle für die zollfreie Einfuhr in die Russische Föderation überschritten wird',
    orderMemberFullNameInfo: 'Alle Informationen sind in kyrillischer Schrift ausgefüllt',
    orderMemberCityInfo: 'Bitte geben Sie den Namen der Stadt auf Englisch ein',
    orderMemberStreetInfo: 'Bitte schreiben Sie den Straßennamen in Transliteration',
    orderMemberRegionInfo: 'Bitte geben Sie den Namen der Region auf Englisch ein',
    orderPackageItemUrl: 'Produktlink',
    orderPackagePickupDate: 'Abholdatum',
    expressShipment: 'EXPRESS-Tarif',
    regularShipment: 'STANDART Tarif',
    parcelInsurance: 'Paketversicherung',
    myPurchases: 'Meine Einkäufe',
    shopName: 'Shop',
    warehouse: 'Lager',
    goodsList: 'Produktliste',
    goods: 'Produkt',
    myAddresses: 'Meine Adressen',
    address: 'Adresse',
    companyName: 'Empfänger des Pakets',
    postalCode: 'Postleitzahl',
    workMode: 'Arbeitsmodus',
    fullName: 'Name Vorname',
    orderType: 'Art der Bestellung',
    perItem: 'pro Artikel',
    parcelDimensionsAttentionInformation: 'Bitte geben Sie Maße und Gewicht korrekt ein! Bei Abweichungen zwischen den angegebenen und den tatsächlichen Daten werden die Kosten der Dienstleistung angepasst.',
    promoCode: 'Aktionscode',
    apply: 'Anwenden',
    discount: 'Rabatt',
    paidAmount: 'Bezahlte Menge',
    goodName: 'Produktname',
    representativePlaceholder: 'Fedorov Fedor Fedorovich',
    acceptTermsOfService: 'Ich akzeptiere die Bedingungen der aktuellen Offerte',
    itemTotalCost: 'Gesamtpreis dieses Artikels',
    addPurchase: 'Fügen Sie einen Kauf hinzu',
    addGood: 'Produkt hinzufügen',
    purchaseAdding: 'Einen Kauf hinzufügen',
    productAdding: 'Ein Produkt hinzufügen',
    acceptPersonalData: 'Ich stimme der Verarbeitung personenbezogener Daten zu',
    acceptTermsOfUse: 'Ich akzeptiere die Nutzungsbedingungen des Dienstes',
    courierPickUpInfo: 'Die Abholzeiten sind von 08-18 Uhr',
    inn: 'Steuernummer',
    glsParcelShops: 'Shop-Stelle suchen',
    totalWeight: 'Gesamtgewicht',
    warehouseAddresses: 'Lageradressen',
    parcels: 'Paketsendung',
    orders: 'Bestellungen',
    parcelType: 'Flurstücksart',
    fillOrderPackages: 'Geben Sie den Inhalt des Pakets an',
    autoFill: 'Autovervollständigen',
    sendingParcelToRussia: 'Ein Paket nach Russland versenden',
    shoppingFromStores: 'Einkaufen aus Online-Shop',
    china: 'China',
    europe: 'Europa',
    howToMakeOrder: 'Wie kann ich eine Bestellung aufgeben?',
    faq: 'FAQ',
    calculator: 'Kalkulator',
    support: 'Support-Service',
    openMenu: 'Menü öffnen',
    selectPurchasesError: 'Wählen Sie Ihren zu versendenden Einkauf aus',
    pleaseDownloadLabel: 'Vergessen Sie nicht, Label auszudrucken',
    addFirstPurchase: 'Einkauf № 1 hinzufügen',
    addMorePurchase: 'Einen weiteren Einkauf hinzufügen',
    orderWithWarehouseInfo: 'Bei Bestellungen vom Marktplätzen bitten wir Sie, als Empfänger der Bestellung unser Unternehmen anzugeben und als Lieferadresse die Adresse unseres jeweiligen Lagers anzugeben.',
    regularParcel: 'Regelmäßige Zustellung',
    contacts: 'Kontakte',
    costMustBePositive: 'Die Kosten müssen größer als null sein.',
};
